module.exports = __webpack_public_path__ + "static/k12-section-1-img-4edfecfa6eaaf07eb061b3506110b089.png";